import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_98: FaireProductEntity = {
  token: "legacy_prod_abbott-98",
  type: "product",
  name: 'Classic Plant Mister Teal 8" H, 22 oz (Clearance)',
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/b0795368c3db2f72f3e9b018f51be144e5f504ad28f86835e3a2aa458b02f036.jpeg",
  priceDollars: 18,
  msrpDollars: 32,
  subcategory: "Garden Tools",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_garden-outdoor"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
